import { useErrorModalContext } from "@/contexts/ErrorModalContext";
import type { RomanApiError } from "@roman/shared/lib/net/romanApi";
import { getErrorMessage } from "@roman/shared/utils/error";

export const useHandleApiError = () => {
  const { openModal } = useErrorModalContext();

  const handleError = (title: string) => (error: RomanApiError) => {
    const message = getErrorMessage(error);
    openModal(title, message);
  };

  return {
    handleError,
  };
};
